var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.questionInfo)?_c('fieldset',{staticClass:"question-cnt"},[_c('legend',{staticClass:"heading-1 question-box",attrs:{"aria-live":"polite"}},[_vm._v("\n\t\t"+_vm._s(_vm.questionInfo.question)+"\n\t")]),(
			_vm.questionInfo.cmsLifestyleQuestionFormat.questionFormat ==
				'Multiple options'
		)?_c('ja-single-select',{attrs:{"answers":_vm.answers,"selected-answer":_vm.selectedAnswer},on:{"answerSelected":_vm.selectAnswer}}):(
			_vm.questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'Multi Select'
		)?_c('ja-multi-select',{attrs:{"answers":_vm.answers,"selected-answer":_vm.selectedAnswer},on:{"answerSelected":_vm.selectAnswer}}):(
			_vm.questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'True / False'
		)?_c('ja-true-false-question',{attrs:{"selected-answer":_vm.selectedAnswer},on:{"answerSelected":_vm.selectAnswer}}):(
			_vm.questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'Text Only'
		)?_c('ja-free-text-question',{attrs:{"selected-answer":_vm.selectedAnswer},on:{"answerSelected":_vm.selectAnswer}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }